/**
 * Editorial Kinetic Typography
 * Adds motion design to content sections throughout the About page
 */

class EditorialKineticTypography {
  constructor() {
    this.init();
  }
  
  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }
  
  setup() {
    this.initSectionTitles();
    this.initPrincipleTitles();
    this.initTextReveals();
    this.setupScrollObserver();
  }
  
  /**
   * Animate section titles with split reveal
   */
  initSectionTitles() {
    const titles = document.querySelectorAll('.editorial-heading, .editorial-section-title');
    
    titles.forEach(title => {
      this.splitTextIntoWords(title);
    });
  }
  
  /**
   * Animate principle titles with character reveal
   */
  initPrincipleTitles() {
    const principles = document.querySelectorAll('.editorial-principle h3');
    
    principles.forEach(title => {
      this.splitTextIntoCharacters(title);
    });
  }
  
  /**
   * Split text into words for animation
   */
  splitTextIntoWords(element) {
    const text = element.textContent;
    const words = text.split(' ');
    element.innerHTML = '';
    element.classList.add('kinetic-text');
    
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = 'kinetic-word';
      span.textContent = word;
      span.style.setProperty('--word-index', index);
      element.appendChild(span);
      
      if (index < words.length - 1) {
        element.appendChild(document.createTextNode(' '));
      }
    });
  }
  
  /**
   * Split text into characters for animation
   */
  splitTextIntoCharacters(element) {
    const text = element.textContent;
    const chars = text.split('');
    element.innerHTML = '';
    element.classList.add('kinetic-text-chars');
    
    chars.forEach((char, index) => {
      const span = document.createElement('span');
      span.className = 'kinetic-char';
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.setProperty('--char-index', index);
      element.appendChild(span);
    });
  }
  
  /**
   * Initialize text paragraph reveals
   */
  initTextReveals() {
    const paragraphs = document.querySelectorAll('.editorial-text p, .editorial-principle p');
    
    paragraphs.forEach(p => {
      p.classList.add('text-reveal');
    });
  }
  
  /**
   * Setup Intersection Observer for scroll-triggered animations
   */
  setupScrollObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -5% 0px',
      threshold: 0.05
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          
          // Unobserve after animation to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Observe all kinetic elements
    const elements = document.querySelectorAll(
      '.kinetic-text, .kinetic-text-chars, .text-reveal, .editorial-section, .editorial-principle'
    );
    
    elements.forEach(el => observer.observe(el));
  }
}

// Initialize
new EditorialKineticTypography();

export default EditorialKineticTypography;
